import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useLocation } from 'react-router'
import config from '@/config'
import { fontWeights, colors } from '@/styles'
import Skeleton from '@/components/skeleton'

const { APP_PATH } = config

const LabelText = styled.span`
  font-weight: ${fontWeights.medium};
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey16};
  margin: 0;
`
const SubLabelText = styled(LabelText)`
  margin-bottom: 12px;
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
`

const LargeLinkText = styled.a`
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  font-weight: ${fontWeights.medium};
  color: ${colors.link};
  cursor: pointer;
  margin-right: 6px;
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
`

const DocumentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 12px 16px;
  background: #fcf2d9;
  border-radius: 6px;
  margin-bottom: ${({ isAnalyzing }) => (isAnalyzing ? 18 : 0)}px;
`
const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
`

const Empty = ({ isLocked, isAnalyzing, isLoading }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const documentsUrl = `${location?.pathname?.substring(
    0,
    location?.pathname?.lastIndexOf('/')
  )}/documents`
  const handleDocuments = () => window.open(`${APP_PATH}${documentsUrl}`, '_blank')

  if (isLoading) return <Skeleton width="100%" height={40} />
  return (
    <DocumentsWrapper isAnalyzing={isAnalyzing}>
      <SubLabelText isLocked={isLocked}>
        {t(
          'l.application.view.you_can_still_view.label',
          'You can still view financial documents that have been verified by the liv.rent team.'
        )}
      </SubLabelText>
      <RowContainer isLocked={isLocked}>
        <LargeLinkText onClick={handleDocuments}>
          {t('l.application.view.view_documents.label', 'View Documents')}
        </LargeLinkText>
      </RowContainer>
    </DocumentsWrapper>
  )
}

export default Empty
